import colors from '../tokens/colors';

export const priceButtonGetolo = {
  secureTransaction: {
    colorOutside: colors.PROFESSIONAL_LIGHT_BLUE,
    horizontalAlign: {
      inside: 'center',
      outside: 'center',
    },
    typography: 'subText',
  },
  noRisk: {
    horizontalAlign: 'center',
    title: {
      typography: 'h3',
      color: colors.PROFESSIONAL_BLUE,
    },
    text: {
      typography: 'subText',
      color: colors.PROFESSIONAL_BLUE,
    },
  },
};

export const priceButtonDaDirekt = {
  secureTransaction: {
    colorOutside: colors.DA_DIREKT_BORDER_LINES,
    horizontalAlign: {
      inside: 'center',
      outside: 'flex-start',
    },
    typography: 'subText',
  },
  noRisk: {
    horizontalAlign: 'left',
    title: {
      typography: 'h3',
      color: colors.DA_DIREKT_GRAY_2,
    },
    text: {
      typography: 'subText',
      color: colors.DA_DIREKT_GRAY_2,
    },
  },
};

export const priceButtonDaKaufland = {
  secureTransaction: {
    colorOutside: colors.DA_KAUFLAND_BLACK,
    horizontalAlign: {
      inside: 'center',
      outside: 'flex-start',
    },
    typography: 'p5',
  },
  noRisk: {
    horizontalAlign: 'left',
    title: {
      typography: 'h3',
      color: colors.DA_KAUFLAND_BLACK,
    },
    text: {
      typography: 'p5',
      color: colors.DA_KAUFLAND_BLACK,
    },
  },
};

export const priceButtonFressnapf = {
  secureTransaction: {
    colorOutside: colors.FRESSNAPF_TEXT_PRIMARY,
    horizontalAlign: {
      inside: 'center',
      outside: 'flex-start',
    },
    typography: 'subText',
  },
  noRisk: {
    horizontalAlign: 'center',
    title: {
      typography: 'h3',
      color: colors.FRESSNAPF_TEXT_PRIMARY,
    },
    text: {
      typography: 'p5',
      color: colors.FRESSNAPF_TEXT_PRIMARY,
    },
  },
};
